"use client";

import { TProductBenefitSection } from "@shared/types";
import { ProductBenefitCards, ProductRequirementItems, SectionHeading } from "@shared/ui";

export function ProductBenefitSection({ title, items, requirementTitle, requirementItems }: TProductBenefitSection) {
  return (
    <section className="py-20 sm:py-[100px] relative" style={{ background: "linear-gradient(222.34deg, #1DB0DE 23.84%, #265E78 92.05%)" }}>
      <div className="container relative">
        <div className="flex gap-10 sm:gap-[60px] lg:gap-20 w-full flex-col lg:flex-row">
          <div className="lg:w-[45%] lg:min-w-[45%]">
            <div className="lg:w-[80%] lg:min-w-[80%] mb-10">
              <SectionHeading titleClassName="text-left max-w-full w-full text-white text-5xl md:text-[56px] lg:text-5xl" title={title} />
            </div>

            <div>{items?.length > 0 && <ProductBenefitCards items={items} />}</div>
          </div>

          <div>
            <div className="lg:w-[90%] lg:min-w-[90%] mb-10">
              <SectionHeading titleClassName="text-left max-w-full w-full text-white text-4xl lg:text-5xl" title={requirementTitle} />
            </div>

            <div>
              {requirementItems && requirementItems.length > 0 && (
                <ProductRequirementItems
                  items={requirementItems}
                  indexClassName={"text-primary-700"}
                  textClassName={"text-white"}
                  contentVariant="primary"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
